<section class="section-title">

    <div class="section-title-text">
        <h1 i18n="@@request_types_title">Tipologie di permessi</h1>
    </div>

</section>



<section class="section-content">

    <div class="buttons-container">

        <a (click)="openAddTypeDialog()" class="button">
            <ng-container i18n="@@request_types_add_type">Aggiungi tipologia</ng-container> <span>
                <fa-icon icon="plus-circle"></fa-icon>
            </span>
        </a>

    </div>

    <div id="table-filter-container">

        
        <div class="table-filter">
            <input id="filter-input" (keyup)="onKey($event)" />
            <p i18n="@@request_types_filter">Filtra: </p>
        </div>
    </div>


    <br>
    <br>

    <div class="table-container">
        <!-- fixed-table -->
        <table mat-table matSort #requeststable [dataSource]="table.dataSource" class="simple-table ">

            <ng-container matColumnDef="name">
                <th mat-header-cell mat-sort-header *matHeaderCellDef i18n="@@request_types_name" style="width: 35%;">
                    Nome tipologia
                </th>
                <td mat-cell *matCellDef="let element" class="td-medium"> {{ element.name }} </td>
            </ng-container>

            <ng-container matColumnDef="files">
                <th mat-header-cell mat-sort-header *matHeaderCellDef i18n="@@request_types_files" style="width: 35%;">
                    File richiesti
                </th>
                <td mat-cell *matCellDef="let element" class="td-medium"> {{ element.files }} </td>
            </ng-container>


            <ng-container matColumnDef="viewType">
                <th mat-header-cell *matHeaderCellDef> </th>
                <td mat-cell *matCellDef="let element" class="td-10">
                    <fa-icon icon="magnifying-glass" class="float-right padding-5 icon-clickable"
                        (click)="onRowClicked(element)"></fa-icon>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

        </table>

    </div>

</section>

<app-loading-screen #requestsloader></app-loading-screen>